import TransactionalMessageDetailPage from '../pages/dashboard/components/pages/transactional/TransactionalMessageDetailPage';
export default function TransactionalMessageDetailRoute() { return <TransactionalMessageDetailPage />; }
